import React from 'react'

export type TrendState = {
  isDragging: boolean
}
export type TrendActions = {
  setDragState: (state: TrendState) => void
}

export const TrendContext = React.createContext<
  (TrendState & TrendActions) | undefined
>(undefined)

export const useTrendDnd = (): TrendState & TrendActions => {
  const context = React.useContext(TrendContext)
  if (context === undefined) {
    throw new Error('useTrendDnd must be used within a TrendProvider')
  }
  return context
}
